import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { DailyLogPage } from './daily-log';
import { BodyModule, GridModule, RowFilterModule } from '@progress/kendo-angular-grid';
import { DailyLogComponent } from '../daily-log-component/daily-log-component.component';
import { GapOverlapPageModule } from '../../validation/gap-overlap/gap-overlap.module';
import { DatePickerModule } from '@progress/kendo-angular-dateinputs';
import { DailyLogEmptyStateComponent } from '../daily-log-empty-state-component/daily-log-empty-state-component';
import { ProgressBarComponent } from '../../shared/components/progress-bar/progress-bar';
import { ConfirmationModalComponent } from '../confirmation-modal/confirmation-modal.component';
import { FoundationModule } from '../../../_foundation/foundation.module';
import { SharedModule } from '../../shared/shared.module';
import { TextMaskModule } from 'angular2-text-mask';
import { DirectivesModule } from '../../../directives/directives.module';
import { PtKendoModule } from '../../../_foundation/kendo/modules/pt.kendo.module';
import {
  DailyLogExternalChangeNotificationComponent
} from '../components/daily-log-external-change-notification/daily-log-external-change-notification.component';

@NgModule({
  declarations: [
    DailyLogComponent,
    DailyLogPage,
    DailyLogEmptyStateComponent,
    ProgressBarComponent,
    ConfirmationModalComponent,
    DailyLogExternalChangeNotificationComponent
  ],
  imports: [
    DirectivesModule,
    IonicPageModule.forChild(DailyLogPage),
    GridModule,
    PtKendoModule,
    GapOverlapPageModule,
    DatePickerModule,
    RowFilterModule,
    FoundationModule,
    SharedModule,
    TextMaskModule,
    BodyModule,
  ],
  exports: [
    DailyLogComponent,
    DailyLogEmptyStateComponent,
    ConfirmationModalComponent
  ],
  entryComponents: [
    ConfirmationModalComponent,
  ]
})
export class DailyLogPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/daily-log/daily-log/daily-log.module.ts